import { travelData } from "../state/travelData";

export const getDirectLinkWithTravelData = directLink => {
	const edlUrl = new URL(directLink);
	Object.entries(travelData.formattedRequestParameter).forEach(
		([key, value]) => {
			edlUrl.searchParams.append(key, value);
		},
	);
	return edlUrl;
};
